import ReactGA from 'react-ga4';

// log specific events happening.
export const eventEmitter = (eventDetails: any) => {
  console.log('action: ', eventDetails.action);
  ReactGA.event(eventDetails);
};
